<script lang="ts">
	//Design system components
	import { Button, Modal, Text, Container } from '@Shelly/shelly-design-system';

	import type { ButtonPropsTypes } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from '../helpers/utilities';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let showModal = true;
	export let props: {
		title?: string;
		text?: string;
		subtext?: string;
		value?: string;
		button_1?: string;
		button_1_variant?: ButtonPropsTypes['variant'];
		button_2?: string;
		callback?: () => void;
	};
</script>

<Modal {showModal} on:close={() => (showModal = false)} title={props.title}>
	<svelte:fragment slot="content">
		<Container padding="0">
			{#if props.text}
				<Text>{props.text}</Text>
			{/if}
			{#if props.subtext}
				<Text class={props.text ? 'mt-s mb-s' : 'mb-s'}>{props.subtext}</Text>
			{/if}
			<slot />
		</Container>
	</svelte:fragment>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			on:click={() => {
				showModal = false;
			}}
		>
			{capFirstChar(props.button_2)}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
			variant={props.button_1_variant || 'primary'}
			on:click={() => {
				showModal = false;
				props.callback(props.value);
			}}
		>
			{capFirstChar(props.button_1)}
		</Button>
	</div>
</Modal>
